import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

interface AgreementQuickCommentPopoverProps {
  children: React.ReactNode;
  onAddComment: (comment: string) => void;
}

export const AgreementQuickCommentPopover = ({
  children,
  onAddComment,
}: AgreementQuickCommentPopoverProps) => {
  const { t } = useTranslation();
  const [comment, setComment] = useState("");
  const [open, setOpen] = useState(false);

  const handleSubmit = () => {
    if (comment.trim()) {
      onAddComment(comment);
      setComment("");
      setOpen(false);
    }
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent className="w-80" align="end">
        <div className="space-y-3">
          <h4 className="font-medium text-sm">
            {t("agreements.comments.quickAdd")}
          </h4>
          <Textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder={t("agreements.comments.addPlaceholder")}
            rows={3}
            className="resize-none"
          />
          <div className="flex justify-end gap-2">
            <Button
              size="sm"
              variant="outline"
              onClick={() => {
                setComment("");
                setOpen(false);
              }}
            >
              {t("common.cancel")}
            </Button>
            <Button size="sm" onClick={handleSubmit} disabled={!comment.trim()}>
              {t("agreements.comments.add")}
            </Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};
